import React, { useState } from 'react';
import { resetPassword, sendOtp, verifyOtp } from '../api/APIService';
import Toast from './Toast';
import { useNavigate } from 'react-router-dom';
import Loader from './Loader';

const ForgotPassword = () => {
  const [step, setStep] = useState(1);
  const [email, setEmail] = useState('');
  const [otp, setOtp] = useState('');
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [errors, setErrors] = useState({});
  const [toast, setToast] = useState({ show: false, message: '', type: 'success' });
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate()


  const handleEmailSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!email.trim() || !/^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(email)) {
      newErrors.email = "Please provide valid email.";
    }
    if (Object.keys(newErrors).length === 0) {
      try {
        setLoading(true);
        const response = await sendOtp({ username: email, email: email });
        console.log(response);
        if (response.status === 200) {
          setToast({ show: true, message: response.data, type: 'success' })
          setStep(2);
        } else {
          setToast({ show: true, message: "Something went wrong, please try again!", type: 'error' })
        }
      } catch (error) {
        setToast({ show: true, message: error.response?.data, type: 'error' })
        newErrors.email = error.response?.data;
      } finally {
        setLoading(false);
      }
    }
    setErrors(newErrors);

  };


  const handleOtpSubmit = async (e) => {
    e.preventDefault();
    const newErrors = {};
    if (!otp.trim() || !/^\d{6}$/.test(otp)) {
      newErrors.otp = "Please provide valid OTP";
    }
    if (Object.keys(newErrors).length === 0) {
      setLoading(true);
      try {
        const response = await verifyOtp({ username: email, email: email, otp: otp });
        console.log(response);
        if (response.status === 200) {
          setToast({ show: true, message: response.data, type: 'success' })
          setStep(3);
        } else {
          setToast({ show: true, message: "Something went wrong, please try again!", type: 'success' })
        }
      } catch (error) {
        setToast({ show: true, message: error.response?.data, type: 'error' })
        newErrors.otp = error.response?.data;
      } finally {
        setLoading(false);
      }
    }
    setErrors(newErrors);
  };

  const handlePasswordSubmit = async (e) => {
    e.preventDefault();
    const passwordRegex = /^[a-zA-Z0-9!@#$%^&*]{4,}$/;
    const newErrors = {};
    if (!newPassword || !passwordRegex.test(newPassword.trim())) {
      newErrors.newPassword = "Please provide valid password.";
    }
    if (confirmPassword !== newPassword) newErrors.confirmPassword = "Password do not match";
    if (Object.keys(newErrors).length === 0) {
      try {
        setLoading(true);
        const response = await resetPassword({ username: email, email: email, otp: otp, password: newPassword });
        if (response.status === 200) {
          setToast({ show: true, message: response.data, type: 'success' })
          navigate("/login");
        } else {
          setToast({ show: true, message: "Something went wrong, please try again!", type: 'error' })
        }
      } catch (error) {
        setToast({ show: true, message: error.response?.data, type: 'error' })
        newErrors.newPassword = error.response?.data;
      }finally{
        setLoading(false);
      }
    }
    setErrors(newErrors);

  };

  return (
    <div className="container mt-5">
      <div className="row justify-content-end">
        <div className="col-md-5">
          <div className="card">
            <div className="card-body">
              {step === 1 && (
                <>
                  <h1 className="text-center mb-4">Forgot Password</h1>
                  <form onSubmit={handleEmailSubmit}>
                    <div className="mb-3">
                      {errors.email && <p className="error-text"><span>{errors.email}</span></p>}
                      <input
                        className="form-control"
                        placeholder="Email"
                        value={email}
                        onChange={(e) => setEmail(e.target.value)}
                      />
                    </div>
                    <button type="submit" className="btn btn-teal w-100">Send OTP</button>
                  </form>
                </>
              )}
              {step === 2 && (
                <>
                  <h1 className="text-center mb-4">Verify OTP</h1>
                  <form onSubmit={handleOtpSubmit}>
                    <div className="mb-3">
                      {errors.otp && <p className="error-text"><span>{errors.otp}</span></p>}
                      <input
                        type="number"
                        className="form-control"
                        placeholder="Enter OTP"
                        value={otp}
                        onChange={(e) => setOtp(e.target.value)}
                      />
                    </div>
                    <button type="submit" className="btn btn-teal w-100">Verify OTP</button>
                  </form>
                </>
              )}
              {step === 3 && (
                <>
                  <h1 className="text-center mb-4">Reset Password</h1>
                  <form onSubmit={handlePasswordSubmit}>
                    <div className="mb-3">
                      {errors.newPassword && <p className="error-text"><span>{errors.newPassword}</span></p>}
                      <input
                        type="password"
                        className="form-control"
                        placeholder="New Password"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                    </div>
                    <div className="mb-3">
                      {errors.confirmPassword && <p className="error-text"><span>{errors.confirmPassword}</span></p>}
                      <input
                        type="password"
                        className="form-control"
                        placeholder="Confirm Password"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </div>
                    <button type="submit" className="btn btn-teal w-100">Reset Password</button>
                  </form>
                </>
              )}
            </div>
          </div>
        </div>
      </div>
      <Toast
        show={toast.show}
        message={toast.message}
        type={toast.type}
        onClose={() => setToast({ ...toast, show: false })}
      />
       <Loader show={loading} />
    </div>
  );
};

export default ForgotPassword;